import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'groupBy', standalone: false })
export class GroupByPipe implements PipeTransform {
  transform(collection: any[], property: string): any[] {
    if (!collection) return null;

    const groupedCollection = collection.reduce((previous, current) => {
      const key = current[property] || 'Other';
      if (!previous[key]) {
        previous[key] = [current];
      } else {
        previous[key].push(current);
      }
      return previous;
    }, {});

    const result = Object.keys(groupedCollection).map((key) => ({
      key,
      items: groupedCollection[key],
    }));

    return result.sort((a, b) => {
      const orderA = a.items[0]?.order ?? 0;
      const orderB = b.items[0]?.order ?? 0;

      if (orderA < orderB) return -1;
      if (orderA > orderB) return 1;
      return 0;
    });
  }
}
